import { DefaultPrimaryButton, DefaultSecondaryButton } from '@frontend/components/common';
import { Spinner } from '@frontend/elements';
import { CommonMessage } from '@frontend/lang';

import { SettingFieldInput } from '../setting-field-input/setting-field-input.component';
import useSettingCreate from './setting-create.controller';

export const SettingCreate = () => {
    const viewProps = useSettingCreate();
    if (viewProps.isLoading) {
        return <Spinner />;
    }
    return (
        <div className='card mt-3 w-full lg:w-1/2'>
            <div className='card-body'>
                <h4 className='flex flex-row'>Update&nbsp;{viewProps.entity_type && <>{viewProps.entity_type}&nbsp;</>}settings</h4>

                <div className='mt-8 flex w-full flex-col gap-4'>
                    {viewProps.template ? (
                        viewProps.template.map((template) => {
                            const currentValue = viewProps.formValues[template.key]?.value;
                            const value = template.type === 'bool' ? currentValue === true : (currentValue ?? null);

                            return (
                                <SettingFieldInput
                                    key={template.key}
                                    targetEntityId={viewProps.entity_id}
                                    targetEntityType={viewProps.entity_type}
                                    type={template.type}
                                    value={value}
                                    onChange={(v) => {
                                        const entityType = viewProps.entity_type;
                                        const entityId = viewProps.entity_id;
                                        if (!entityType || !entityId) return;

                                        viewProps.setFormValues((prev) => ({
                                            ...prev,
                                            [template.key]: {
                                                key: template.key,
                                                entity_type: entityType,
                                                entity_id: entityId,
                                                value: v
                                            }
                                        }));
                                    }}
                                    label={template.key.replace(/_/g, ' ')}
                                    options={template.options}
                                />
                            );
                        })
                    ) : (
                        <p>No settings for this type</p>
                    )}
                </div>
            </div>

            <div className='card-footer flex justify-between'>
                <DefaultSecondaryButton
                    onClick={viewProps.onCancel}
                    text={CommonMessage.BUTTONS.CANCEL}
                />
                <DefaultPrimaryButton
                    onClick={viewProps.onSubmit}
                    text={CommonMessage.BUTTONS.SUBMIT}
                    disabled={!viewProps.template}
                />
            </div>
        </div>
    );
};
